import React, { memo } from "react";
import { StyleSheet } from "react-native";
import SupportButton from "@components/SupportButton";
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context";
import OpenSettingsModal from "@screens/LocationServiceablity/OpenSettingsModal";
import SnackBarComponent from "@components/SnackBar";
import SuspensionModal from "@components/SuspensionModal";
import LocationStreamListener from "@components/LocationStreamListener";
import RootContainer from "./Main";

const App = memo(() => (
  <SafeAreaProvider>
    <SafeAreaView style={styles.container}>
      <RootContainer />
      <SnackBarComponent />
      <OpenSettingsModal />
      <SupportButton />
      <SuspensionModal />
      <LocationStreamListener />
    </SafeAreaView>
  </SafeAreaProvider>
));
export default App;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
